import { cva } from "class-variance-authority";

export const variants = cva(
  [
    "inline-flex",
    "items-center",
    "justify-center",
    "relative",
    "cursor-pointer",
    "disabled:cursor-not-allowed",
    "tracking-wide",
    "transition",
    "rounded-full",
    "outline-none",
  ],
  {
    variants: {
      variant: {
        primary: [
          "font-semibold",
          "bg-primary-500",
          "hover:bg-primary-600",
          "active:bg-primary-700",
          "text-white",
          "disabled:bg-primary-500/50",
          "ring-offset-2",
          "focus-visible:ring-2",
          "ring-primary-500/70",
        ],
        danger: [
          "font-semibold",
          "bg-red-600",
          "hover:bg-red-500",
          "active:bg-red-700",
          "text-white",
          "disabled:bg-red-500/50",
          "ring-offset-2",
          "focus-visible:ring-2",
          "ring-red-500/70",
        ],
        dangerText: [
          "font-semibold",
          "bg-white",
          "text-red-500",
          "border-solid",
          "border",
          "border-red-500",
          "hover:border-red-400",
          "hover:bg-red-500",
          "hover:text-white",
          "active:bg-red-300",
          "disabled:bg-slate-100",
        ],
        grey: [
          "font-semibold",
          "bg-white",
          "text-neutral-900",
          "border-solid",
          "border",
          "border-neutral-900",
          "hover:border-neutral-400",
          "hover:bg-neutral-200",
          "active:bg-neutral-300",
          "disabled:bg-slate-100",
        ],
        greyLight: [
          "font-semibold",
          "bg-neutral-100",
          "text-neutral-900",
          "border-solid",
          "border",
          "border-neutral-300",
          "hover:bg-neutral-200",
          "active:bg-neutral-300",
          "disabled:bg-slate-100",
        ],
        greyLightNoBorder: [
          "font-semibold",
          "bg-white",
          "text-neutral-900",
          "border-solid",
          "hover:bg-neutral-200",
          "active:bg-neutral-300",
          "disabled:bg-slate-100",
        ],
      },
      size: {
        small: ["text-sm", "min-h-9", "py-1", "px-5"],
        default: ["text-sm", "min-h-10", "py-2", "px-5"],
        iconSmall: ["w-10", "h-10", "p-2"],
      },
      width: {
        full: ["w-full"],
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  },
);
